const prefix = 'ATTENDANCE_';

export const GET_CLASS_LIST = `${prefix}GET_CLASS_LIST`;
